module.exports = {
  "SAN DIEGO WAVE FÚTBOL CLUB": [
    {
      "Title": "SAN DIEGO WAVE FÚTBOL CLUB",
      "content":[
        {
          "type":"text",
          "text":"The new brand platform: #TogetherSomosGreater created by Lovers Not Haters,<br class='responsive-break'> reflects the inclusivity-centric philosophy the new expansion team is championing<br class='responsive-break'> on and off the field. Most importantly, it celebrates the diversity and power of the<br class='responsive-break'> collective in Greater San Diego, a diverse community that is joining forces with<br class='responsive-break'> their new team to bring a wave of good, inclusion and togetherness.<br class='responsive-break'> Because as the end frame of our first anthem spot says in Spanglish,<br class='responsive-break'> English/Chinese and English/Tagalog: Together Somos Greater."
        },
        { type: "text", text: "<br><br><b>Anthem - TV :90</b>" },
        {
          "type":"text",
          "text":"We launched the TOGETHER SOMOS GREATER<br class='responsive-break'>platform with a :90 Anthem Spot that makes it clear our new<br class='responsive-break'>San Diego team it’s here for something bigger than just winning."
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/QYbuCeF1-Iw?rel=0&showinfo=0",
        },
        { type: "text", text: "<br><br><b>Ex-Chargers - Online Video :40</b>" },
        {
          "type":"text",
          "text":"In this OLV, the team lets 30k+ ex-Charger fans who were left without a team<br class='responsive-break'> when the NFL team left the city that there’s a new team to love.<br class='responsive-break'>“The team that will be passed on from generation to generation. Not from city to city”."
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/FuUHFNplQ_g?rel=0&showinfo=0",
        },
        { type: "text", text: "<br><br><b>Mujeres Brewery - Online Video :40</b>" },
        {
          "type":"text",
          "text":"This OLV celebrates the reciprocal support between the team and a local<br class='responsive-break'> women-owned, latino-managed brewery in Barrio Logan<br class='responsive-break'> And how they show up for each other."
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/_Ce0V-C26HA?rel=0&showinfo=0",
        },
        // {
        //   "type":"text",
        //   "text":`The new brand platform: #TogetherSomosGreater created by Lovers Not Haters,`
        // },
        // {
        //   "type":"text",
        //   "text":`reflects the inclusivity-centric philosophy the new expansion team is championing`
        // },
        // {
        //   "type":"text",
        //   "text":`reflects the inclusivity-centric philosophy the new expansion team is championing`
        // },
      ]

    }
  ],
  "BUD LIGHT PARTY": [
    {
      Title: "THE BUD LIGHT PARTY",
      content: [
        {
          type: "text",
          text:
            "During an electoral year (2016), America can’t agree on much.<br>So Bud Light decided to bring the entire country together<br>by reminding us about the things that unite us. Like, beer.",
        },
        {
          type: "press",
          title: "PRESS",
          links: [
            {
              name: "ANHEUSER-BUSCH",
              href:
                "http://www.anheuser-busch.com/newsroom/2016/02/superbowl2016.html",
            },
            {
              name: "YAHOO",
              href:
                "https://es-us.vida-estilo.yahoo.com/comercial-super-bowl-espa%C3%B1ol-michael-120037533.html",
            },
            {
              name: "DIGITAL TRENDS",
              href:
                "https://es.digitaltrends.com/deportes/super-bowl-historico-latinos/",
            },
            {
              name: "CHICAGO TRIBUNE",
              href:
                "http://www.chicagotribune.com/hoy/ct-hoy-8554343-voto-latino-con-michael-pena-comercial-de-bud-light-del-super-bowl-2016-story.html",
            },
            {
              name: "CAMPAIGN LIVE",
              href:
                "http://www.campaignlive.com/article/bud-lights-first-spanish-language-super-bowl-spot-air-espn-deportes/1382546",
            },
            {
              name: "GOAL.COM",
              href:
                "http://www.goal.com/en-us/news/587/copa-america/2016/06/05/24323062/everything-is-possible-except-chicharito-in-a-usa-kit",
            },
            {
              name: "VARIETY LATINO",
              href:
                "http://varietylatino.com/2016/gente/noticias/comercial-bud-light-copa-america-michael-pena-chicharito-242047/",
            },
          ],
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/KK720gmxvcE?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/-XqcfczdbW0?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/bsW5JMoEWtA?rel=0&showinfo=0",
        },
        {
          type: "slides",
          pictures: [
            "/static/works/content/CadaBudLight.png",
            "/static/works/content/CambioElLook.png",
            "/static/works/content/Ciudadano.png",
            "/static/works/content/ElEquipoDelEquipo.png",
            "/static/works/content/ElFuturoEsta.png",
            "/static/works/content/Houston.png",
            "/static/works/content/LAtinosInTheHouse.png",
            "/static/works/content/PorDentroNever.png",
            "/static/works/content/PorLosGigantes.png",
            "/static/works/content/SeVeComoNunca.png",
            "/static/works/content/UnPartyAlQue.png",
            "/static/works/content/VotePorElNuevoBote.png",
            "/static/works/content/VotosBotas.png",
          ],
        },
      ],
    },
    {
      Title: "BUD LIGHT COPA AMERICA",
      content: [
        {
          type: "text",
          text:
            'The Bud Light Party teamed up with Mexican National Team and International star Javier "Chicharito" Hernandez for Copa America.',
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/eYauX_PxiVY?rel=0&showinfo=0",
        },
        { type: "image", src: "/static/works/content/MenosRedCards.png" },
        {
          type: "imagesCols",
          cols: 4,
          pictures: [
            "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-1.png",
            "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-2.png",
            "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-3.png",
            "/static/works/content/VI_OOH_Hispanic_Copa_BusShelter_v4-1-5.png",
          ],
        },
        { type: "text", text: "<b>Radio</b>" },
        {
          type: "radio",
          comercial: [
            {
              name: "Los Taco Salads",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Taco_Salad_HISP_30_RADIO_041316_Mix.mp3",
            },
            {
              name: "El Sueño Americano",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Sueno_Americano_HISP_30_RADIO_041316_Mix.mp3",
            },
            {
              name: "El Tamaño de los Apartamentos",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Small_Apartments_HISP_30_RADIO_041316_Mix.mp3",
            },
            {
              name: "El Patriotismo",
              url: "https://lnhcdn.nyc3.digitaloceanspaces.com/patriotismo.mp3",
            },
            {
              name: "El Debate",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Debate_HISP_30_RADIO_041316_Mix.mp3",
            },
            {
              name: "La Música en los Elevadores",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Elevadores_Bachata_HISP_30_RADIO_041316_Mix.mp3",
            },
            {
              name: "El Futbol no el Football",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/El_Futbot_Not_El_Football_HISP_30_RADIO_041316_Mix.mp3",
            },
            {
              name: "Nuestros Apellidos",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Apellido_HISP_30_RADIO_041316_Mix.mp3",
            },
            {
              name: "5 de Mayo",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/5_De_Mayo_HISP_30_RADIO_041316_Mix.mp3",
            },
          ],
        },
      ],
    },
  ],
  "TARGET EASTER": [
    {
      Title: "TARGET EASTER",
      content: [
        { type: "video", url: "https://player.vimeo.com/video/606809994?h=39bdd573a3" },
        { type: "video", url: "https://player.vimeo.com/video/604321093" },
        // { type: "video", url: "https://player.vimeo.com/video/604321690" },
        // { type: "video", url: "https://player.vimeo.com/video/604320692" },
      ],
    },
  ],
  "THE LETGO COMMERCIALIZER": [
    {
      Title: "THE LETGO COMMERCIALIZER",
      content: [
        {
          type: "text",
          text:
            "The Commercializer is a feature within the Letgo app that lets users promote their second-hand goods online by creating their own version of a big-budget commercial. Fans are making over 10,000 custom videos each day and about 1.16 million total videos to date.",
        },
        {
          type: "press",
          title: "PRESS",
          links: [
            { name: "LETGO", href: "https://us.letgo.com/en/" },
            {
              name: "ADWEEK",
              href:
                "http://www.adweek.com/adfreak/apps-commercializer-turns-any-boring-classified-ad-big-budget-blockbuster-170938",
            },
            {
              name: "CREATIVITY ONLINE",
              href:
                "http://creativity-online.com/work/letgo-commercializer/46559",
            },
            {
              name: "FUNNY OR DIE ",
              href:
                "http://www.funnyordie.com/articles/de9c439648/we-used-letgo-to-sell-weird-stuff-from-the-fod-office",
            },
            {
              name: "DIGIDAY",
              href:
                "http://digiday.com/brands/letgos-new-tool-lets-users-make-blockbuster-ads-sell-junk",
            },
            {
              name: "BUSINESS NEWS",
              href:
                "http://business.truebreakingnews.com/2016/08/24/letgos-commercializer-generates-hollywood-fashion-advertisements-so-customers-can-promote-their-previous-stuff",
            },
            {
              name: "CAMPAIGN LIVE",
              href:
                "http://www.campaignlive.co.uk/article/dolph-lundgren-will-sell-stuff-custom-ad-crispin/1392102",
            },
          ],
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/-QSZ-sR5bYo?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/D1TRXVg7Q5Q?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/Qv-z2lJBV60?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/L6sFHKXcnns?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/0zER7YLvP9E?rel=0&showinfo=0",
        },
      ],
    },
  ],
  "GOOGLE IWD 2021": [
    {
      Title: "GOOGLE INTERNATIONAL WOMEN'S DAY",
      content: [
        {
          type: "text",
          text:
            '<div class="container" style="max-width:75%;"><p>Celebrating the first women who made way for the many.</p></div>',
        },
        { type: "video", url: "https://player.vimeo.com/video/518892608" },
        // {
        //   type: "text",
        //   text:
        //     "<span style='font-size:80%'>Translation: 1. Entire place ✅. 2. Pool ✅. 3. Holiday homes as you like them. 4. Airbnb. Come on in.</span>",
        // },
      ],
    },
  ],
  "GOOGLE YEAR IN SEARCH 2020": [
    {
      Title: "GOOGLE YEAR IN SEARCH 2021",
      content: [
        {
          type: "text",
          text:
            '<div class="container" style="max-width:75%;"><p>Helping Google make their famous Year in Search more global and inclusive.</p></div>',
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/rokGy0huYEA?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/d5ZzM-4mF8w?rel=0&showinfo=0",
        },
        // {
        //   type: "text",
        //   text:
        //     "<span style='font-size:80%'>Translation: 1. Entire place ✅. 2. Pool ✅. 3. Holiday homes as you like them. 4. Airbnb. Come on in.</span>",
        // },
      ],
    },
  ],
  VRBO: [
    {
      Title: "VRBO",
      content: [
        {
          type: "text",
          text:
            '<div class="container" style="max-width:75%;"><p>Vrbo came to us to help them reactivate vacation home rentals among Hispanic families after the pandemic. Doing work in both English and Spanish, we accomplished our goal by appealing to and celebrating the "Host at Heart", that person in the family whose favorite part of the vacation is seeing the rest of the family enjoy.</p></div>',
        },
        { type: "video", url: "https://player.vimeo.com/video/604272351" },
        { type: "video", url: "https://player.vimeo.com/video/604271440" },
        { type: "video", url: "https://player.vimeo.com/video/604271905" },
        { type: "video", url: "https://player.vimeo.com/video/604271202" },
        { type: "video", url: "https://player.vimeo.com/video/604270481" },
        { type: "video", url: "https://player.vimeo.com/video/604270724" },
      ],
    },
  ],
  "GOOGLE SEARCHING FOR A WAY": [
    {
      Title: "GOOGLE'S FIRST-EVER BRAND CAMPAIGN FOR THE LATINO MARKET",
      content: [
        {
          type: "text",
          text:
            '<div class="container" style="max-width:800px"><b>Lovers Not Haters launches Google\'s first-ever brand campaign <br>for the U.S. Latino market.</b><p>In July 2020, LNH was selected by Google to work on an awareness campaign to help Latino-owned businesses economically recover from the pandemic. </p><p>The campaign, which launched in September 2020 during Hispanic Heritage month, celebrates the Latino community\'s resilience in times of adversity and the "Nunca dejamos de buscarle" or "We never stop searching for a way" attitude that gets us through anything. </p><p>For us, it was about more than advertising. It was our opportunity to help our community and those businesses near us that never give up and always find a way. </p><p>The campaign consists of a series of TV spots and 30s/15s/06s online videos, social and digital assets for Snapchat and Twitter, as well as Pandora audios.</p></div>',
        },
        { type: "text", text: "<b>TV</b>" },
        { type: "text", text: "<span style='font-size:80%'>Buscándole</span>" },
        {
          type: "video",
          url: "https://www.youtube.com/embed/8pdLAYzjApk?rel=0&showinfo=1",
        },
        {
          type: "text",
          text: "<span style='font-size:80%'>Salir Adelante</span>",
        },
        {
          type: "video",
          url: "https://player.vimeo.com/video/460371961?playsinline=0",
        },
        {
          type: "text",
          text: "<span style='font-size:80%'>D Leon Shoe Repair</span>",
        },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461970852?playsinline=0",
        },
        { type: "text", text: "<span style='font-size:80%'>Barbershop</span>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461970249?playsinline=0",
        },
        {
          type: "text",
          text: "<span style='font-size:80%'>Margarita's Alterations</span>",
        },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461971650?playsinline=0",
        },
        { type: "text", text: "<span style='font-size:80%'>Bakery</span>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461971525?playsinline=0",
        },
        { type: "text", text: "<b>SOCIAL AND DIGITAL</b>" },
        { type: "text", text: "<span style='font-size:80%'>Butcher</span>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461978107?playsinline=0",
        },
        { type: "text", text: "<span style='font-size:80%'>Donuts</span>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461978284?playsinline=0",
        },
        {
          type: "text",
          text: "<span style='font-size:80%'>Juan in a Million</span>",
        },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461974777?playsinline=0",
        },
        { type: "text", text: "<span style='font-size:80%'>Margarita</span>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461974792?playsinline=0",
        },
        { type: "text", text: "<span style='font-size:80%'>El Tigre</span>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461978620?playsinline=0",
        },
        { type: "text", text: "<span style='font-size:80%'>Tonitas</span>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461974992?playsinline=0",
        },
        {
          type: "text",
          text: "<span style='font-size:80%'>Back of the Yards</span>",
        },
        {
          type: "video",
          url: "https://player.vimeo.com/video/461975045?playsinline=0",
        },
        { type: "text", text: "<b>PANDORA AUDIO</b>" },
        {
          type: "radio",
          comercial: [
            {
              name: "Buscándole 30s",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Helpfulness_Consumer_Latinx_HHM_Buscandole_Audio2_US_ES_30s_MP3_Audio.mp3",
            },
            {
              name: "Salir Adelante 30s",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Helpfulness_LatinX_Salir%20Adelante_Audio2_v1_US_ES_30s_MP3_Audio.mp3",
            },
            {
              name: "Buscándole 15s",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Helpfulness_Consumer_Latinx_HHM_Buscandole_Audio1_US_ES_15s_MP3_Audio.mp3",
            },
            {
              name: "Salir Adelante 15s",
              url:
                "https://lnhcdn.nyc3.digitaloceanspaces.com/Helpfulness_LatinX_Salir%20Adelante_Audio1_v1_US_ES_15s_MP3_Audio.mp3",
            },
          ],
        },
      ],
    },
  ],
  SPECIALIZED: [
    {
      Title: "SPECIALIZED",
      content: [
        { type: "text", text: "<b>ARC OPTICS PRINT AD</b>" },
        { type: "image", src: "/static/works/content/ArcAnimated_web.gif" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Headline reads: <br>ACTUAL WEIGHT: The four pages in your left hand. At 17 grams, the Arc Optics are the lightest cycling glasses in the world.<br> This ad was placed in the fourth page of different publications to help the reader experience the actual weight.</span>",
        },
        { type: "text", text: "<b>PRINT ADS</b>" },
        { type: "image", src: "/static/works/content/Specialized_1.png" },
        { type: "image", src: "/static/works/content/Specialized_2.png" },
        { type: "image", src: "/static/works/content/Specialized_3.png" },
        { type: "image", src: "/static/works/content/Specialized_4.png" },
        { type: "image", src: "/static/works/content/Specialized_5.png" },
        {
          type: "imagesCols",
          cols: 3,
          pictures: [
            "/static/works/content/Spec_Poster1.jpg",
            "/static/works/content/Spec_Poster2.jpg",
            "/static/works/content/Spec_Poster3.png",
          ],
        },
        { type: "text", text: "<b>BILLBOARD</b>" },
        { type: "image", src: "/static/works/content/Billboard_ForWeb.gif" },
        { type: "text", text: "<b>MAGAZINE</b>" },
        {
          type: "image",
          src: "/static/works/content/BodyGeometry_forWeb_636.gif",
        },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Body Geometry is science. One part geometry, one part anatomy.<br>Equipment designed to bring you and your bike into perfect alignment. You can never be too SPECIALIZED.</span>",
        },
        { type: "image", src: "/static/works/content/HitTheGround_LAST.gif" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Subscription card style inserts that fall out of magazine.</span>",
        },
        { type: "text", text: "<b>STAPLE AD.</b>" },
        { type: "image", src: "/static/works/content/StapleAd_ForWeb_670.png" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Copy reads: The puncture-resistant Armadillo Elite tire.<br>You never really know what you’ll find on the road.<br>You can never be too SPECIALIZED.</span>",
        },
        { type: "text", text: "<b>TV</b>" },
        {
          type: "video",
          url: "https://www.youtube.com/embed/hti4lW28UQw?rel=0&showinfo=0",
        },
        {
          type: "video",
          url: "https://www.youtube.com/embed/QvJ4k2PjbOo?rel=0&showinfo=0",
        },
      ],
    },
  ],
  AIRBNB: [
    {
      Title: "AIRBNB",
      content: [
        { type: "video", url: "https://player.vimeo.com/video/321522569" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: 1. Entire place ✅. 2. Pool ✅. 3. Holiday homes as you like them. 4. Airbnb. Come on in.</span>",
        },
        { type: "video", url: "https://player.vimeo.com/video/321523230" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: 1. Guests ✅. 2. Pets allowed ✅ 3. Holiday homes as you like them. 4. Airbnb. Come on in.</span>",
        },
        { type: "image", src: "/static/works/content/OOH_Posters_750_750.jpg" },
        {
          type: "text",
          text:
            '<span style=\'font-size:80%\'>Translation: (Left): The whole bunch without getting tangled. (Insight: In México, we say "toda la bola" as in "the whole bunch") <br>(Right): The best vacation. Not the most expensive.</span>',
        },
        { type: "image", src: "/static/works/content/OOH_2_Mockup_750.jpg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: (Left): A vacation like this shouldn't be kept to yourself. <br>(Right): This vacation season bring your favorite son.</span>",
        },
        {
          type: "image",
          src: "/static/works/content/VisitaUnlugar_Web_750.jpg",
        },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: 1. Visit a place… 2. Where your tourist guide… 3. Are your neighbors. 4. More than 90.000 homes in México. Come on in.</span>",
        },
        {
          type: "image",
          src: "/static/works/content/PagasPorUnos_750_750.jpg",
        },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: 1. You pay for a few days… 2. And it last them… 3. A lifetime. 4. Find the home your budget loves the most. Come on in.</span>",
        },
        {
          type: "image",
          src: "/static/works/content/Airbnb_Compilation_750.jpg",
        },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: Feel at home in our home.</span>",
        },
        { type: "video", url: "https://www.youtube.com/embed/fKZVogmBZHE" },
        { type: "video", url: "https://www.youtube.com/embed/SpAHrNvwXLc" },
        { type: "video", url: "https://www.youtube.com/embed/96r76qqx5oU" },
        { type: "video", url: "https://www.youtube.com/embed/-4b9dZCBvPw" },
        { type: "image", src: "/static/works/content/airbnb0.jpg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%;'>Translation: Visit the best country in the world. Yours.</span>",
        },
        { type: "image", src: "/static/works/content/airbnb1.jpeg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%;'>Translation: We take care of the home just as we do our guests.</span>",
        },
        { type: "image", src: "/static/works/content/airbnb2.jpeg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: Feel at home in our home.</span>",
        },
        { type: "image", src: "/static/works/content/airbnb3.jpeg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: Use this corner as your point of reference so you don’t get lost. Although we also recommend you get lost. You’ll have more fun.</span>",
        },
        { type: "image", src: "/static/works/content/airbnb4.jpeg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: The good thing about this neighborhood is that we have a thousand places where to eat. That way your family doesn't have to agree on something.</span>",
        },
        { type: "image", src: "/static/works/content/airbnb5.jpeg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: The moment we hand you the keys, our home becomes yours/is your home.</span>",
        },
        { type: "image", src: "/static/works/content/airbnb6.jpeg" },
        {
          type: "text",
          text:
            "<span style='font-size:80%'>Translation: In our homes, we like to welcome you with fresh flowers. Go for it, pick the ones you like. They’re on us/we’re inviting.</span>",
        },
      ],
    },
  ],
  "TARGET BABY": [
    {
      Title: "TARGET BABY",
      content: [
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/39199711?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/39198393?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "imagesCols",
          cols: 3,
          pictures: [
            "/static/works/content/Ultima-Palabra_623.jpeg",
            "/static/works/content/Esperando_621.jpeg",
            "/static/works/content/Trono_630.jpeg",
          ],
        },
      ],
    },
  ],
  TURBOTAX: [
    {
      Title: "TURBOTAX",
      content: [
        { type: "text", text: "<br><br><b>HISPANIC MARKET 2018</b>" },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/422896219?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/321514770?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/321517323?color=00FFFF&title=0&byline=0&portrait=0",
        },
        { type: "text", text: "<br><br><b>HISPANIC MARKET 2019</b>" },
        // {
        //   type: "video",
        //   url: "https://www.youtube.com/embed/AYb2S0gMA0c?rel=0&showinfo=0",
        // },
        {
          type: "video",
          // url: "https://www.youtube.com/embed/YTwzPxWaVDY?rel=0&showinfo=0",
          url:
            "https://player.vimeo.com/video/422903750?color=00FFFF&title=0&byline=0&portrait=0",
        },
        { type: "text", text: "<br><br><b>General Market</b>" },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/359338797?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/321512781?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/321515996?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/359334571?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/359336322?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/359334668?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/359334728?color=00FFFF&title=0&byline=0&portrait=0",
        },
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/359336353?color=00FFFF&title=0&byline=0&portrait=0",
        },
      ],
    },
  ],
  "DOMESTIC WORKERS": [
    {
      Title: "DOMESTIC WORKERS PSA",
      content: [
        {
          type: "video",
          url:
            "https://player.vimeo.com/video/403801871?color=00FFFF&title=0&byline=0&portrait=0",
        },
      ],
    },
  ],
  "DOMINO’S PIZZA TURNAROUND": [
    {
      Title: "DOMINO’S PIZZA TURNAROUND",
      content: [
        { type: "text", text: "<b>CASE STUDY </b>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/52495336?title=0&byline=0",
        },
        { type: "text", text: "<b>AT THE DOOR OF OUR HARSHEST CRITICS </b>" },
        {
          type: "video",
          url: "https://www.youtube.com/embed/jloxAHLWDsI?rel=0&showinfo=0",
        },
        { type: "text", text: '<b>"ADRIANNE " WEB/TV </b>' },
        {
          type: "video",
          url: "https://www.youtube.com/embed/8654pUOUJAE?rel=0&showinfo=0",
        },
        { type: "text", text: '<b>"SAUL " WEB/TV </b>' },
        {
          type: "video",
          url: "https://www.youtube.com/embed/HQsXSpxFBTA?rel=0&showinfo=0",
        },
        { type: "text", text: '<b>"CLAUDIA " WEB/TV </b>' },
        {
          type: "video",
          url: "https://www.youtube.com/embed/iGtp9iZg5cA?rel=0&showinfo=0",
        },
        { type: "text", text: '<b>"BETTER" PRINT</b>' },
        { type: "image", src: "/static/works/content/dominos_Print_788.jpg" },
      ],
    },
  ],
  LYFT: [
    {
      Title: "LYFT",
      content: [
        { type: "image", src: "/static/works/content/Lyft_Comb_1_1200.jpg" },
        { type: "image", src: "/static/works/content/Lyft_Comb_2_1200.jpg" },
        { type: "image", src: "/static/works/content/Lyft_Comb_3_1200.jpg" },
        { type: "image", src: "/static/works/content/lift4.png" },
        { type: "image", src: "/static/works/content/lift5.png" },
        { type: "image", src: "/static/works/content/lift7.png" },
      ],
    },
  ],
  "RON MONTERO": [
    {
      Title: "RON MONTERO",
      content: [
        { type: "image", src: "/static/works/content/ronmontero1.jpg" },
        { type: "text", text: "ID on products" },
        { type: "image", src: "/static/works/content/ronmontero2345.jpg" },
        { type: "text", text: "Website" },
        { type: "image", src: "/static/works/content/ronmontero67.jpg" },
      ],
    },
  ],
  "KRAFT MACARONI & CHEESE": [
    {
      Title: "KRAFT MACARONI & CHEESE",
      content: [
        { type: "text", text: "<b>TV - HISPANIC - GRANDMA </b>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/660559490",
        },
        { type: "text", text: "<b>TV - HISPANIC - GRAN IDEA </b>" },
        {
          type: "video",
          url: "https://player.vimeo.com/video/660559940",
        },
        { type: "text", text: "<b>BANNER</b>" },
        { type: "image", src: "/static/works/content/Kraft_Banner1.png" },
        { type: "text", text: "<b>BANNER</b>" },
        { type: "image", src: "/static/works/content/Kraft_Banner2.png" },
        {
          type: "text",
          text:
            "<b>RICH MEDIA BANNER</b><br>In this rich media banner the headline will switch from English to Spanish to reinforce the message.",
        },
        { type: "image", src: "/static/works/content/SabeBien.png" },
      ],
    },
  ],
  "VW GOAL CELEBRATION CAMP": [
    {
      Title: "VW GOAL CELEBRATION CAMP",
      content: [
        { type: "text", text: "<b>VW GOAL CELEBRATION CAMPAIGN OVERVIEW </b>" },
        { type: "video", url: "https://www.youtube.com/embed/p8BH6bXtGKk" },
        {
          type: "text",
          text: '<b>VW GOAL CELEBRATION CAMPAIGN - "THE CRANKY DONKEY"</b>',
        },
        { type: "video", url: "https://www.youtube.com/embed/C48ZjOj3PEQ" },
        {
          type: "text",
          text: '<b>VW GOAL CELEBRATION CAMPAIGN - "THE ROCKSTAR"</b>',
        },
        { type: "video", url: "https://www.youtube.com/embed/sWiaT2NbOG0" },
        {
          type: "text",
          text: '<b>VW GOAL CELEBRATION CAMPAIGN - "THE BUNNY HOP"</b>',
        },
        { type: "video", url: "https://www.youtube.com/embed/8tIBe3oAxBU" },
        {
          type: "text",
          text: '<b>VW GOAL CELEBRATION CAMPAIGN - "THE PIÑATA"</b>',
        },
        { type: "video", url: "https://www.youtube.com/embed/cqyB6cL14O4" },
        {
          type: "text",
          text: '<b>VW GOAL CELEBRATION CAMPAIGN - "THE BULLFIGHTER"</b>',
        },
        { type: "video", url: "https://www.youtube.com/embed/xANXR_eD43c" },
        {
          type: "text",
          text: '<b>VW GOAL CELEBRATION CAMPAIGN - "THE WEIGHT LIFT"</b>',
        },
        { type: "video", url: "https://www.youtube.com/embed/YAqKaD2hqAg" },
        {
          type: "text",
          text: '<b>VW GOAL CELEBRATION CAMPAIGN - "TOOT THE BOOT"</b>',
        },
        { type: "video", url: "https://www.youtube.com/embed/0iKKCFpwE4I" },
      ],
    },
  ],
  "YOUTUBE - COPA90": [
    {
      Title: "YOUTUBE - COPA90",
      content: [
        {
          type: "text",
          text:
            "In September 2015, Youtube helped Copa90 create a campaign in the UK to take on<br>big broadcasters and remind fans everywhere that Copa90 is the home of<br>football culture and the true voice of fans around the world.",
        },
        { type: "text", text: "<b>TV - MORE THAN A GAME </b>" },
        { type: "video", url: "https://www.youtube.com/embed/ef2EbRFoEHA" },
        { type: "text", text: "<b>TV - ELI’S STORY</b>" },
        { type: "video", url: "https://www.youtube.com/embed/VBxrW5zbdvE" },
        // { type: "text", text: "<b>TV - AROUND THE WORLD</b>" },
        // { type: "video", url: "https://www.youtube.com/embed/i5xBKBUwvr8" },
        // { type: "text", text: "<b>TV - BEST JOB</b>" },
        // { type: "video", url: "https://www.youtube.com/embed/WFqm3xMwsJs" },
        // { type: "text", text: "<b>TV - CAN’T LIVE WITHOUT IT</b>" },
        // { type: "video", url: "https://www.youtube.com/embed/OpjXhVh4n-M" },
        // { type: "text", text: "<b>TV - PART OF THE FAMILY</b>" },
        // { type: "video", url: "https://www.youtube.com/embed/6dPZmC24u0o" },
        // { type: "text", text: "<b>TV - GLOBAL VOICES</b>" },
        // { type: "video", url: "https://www.youtube.com/embed/yYWfhyovMco" },
        // { type: "text", text: "<b>TV - NEW GOAL</b>" },
        // { type: "video", url: "https://www.youtube.com/embed/-twSbvGNM7w" },
      ],
    },
  ],
  "YOU ARE FALLON": [
    {
      Title: "YOU ARE FALLON",
      content: [
        {
          type: "text",
          text:
            "Would you give up a Cannes Lion or a One Show pencil if you knew you would<br>never see it again? Some of the most famous people in advertising did.",
        },
        { type: "text", text: "<b>YOU ARE FALLON - CAMPAIGN OVERVIEW</b>" },
        { type: "video", url: "https://www.youtube.com/embed/o9eldU4c_u0" },
        { type: "text", text: "<b>TV - THE FIND</b>" },
        { type: "video", url: "https://www.youtube.com/embed/_rx2O515lj8" },
        { type: "text", text: "<b>TV - JAMIE BARRET</b>" },
        { type: "video", url: "https://www.youtube.com/embed/Z6rBlVK9l7o" },
        { type: "text", text: "<b>TV - PAT FALLON</b>" },
        { type: "video", url: "https://www.youtube.com/embed/VAW-j3yxItU" },
        { type: "text", text: "<b>TV - BOB BARRIE</b>" },
        { type: "video", url: "https://www.youtube.com/embed/emxuAYU3l2E" },
        { type: "text", text: "<b>YOU ARE FALLON CAMPAIGN - POSTERS</b>" },
        { type: "image", src: "/static/works/content/Poster_1_1149.jpg" },
        { type: "image", src: "/static/works/content/Poster_2_1149.jpg" },
        { type: "image", src: "/static/works/content/Poster_3_1149.jpg" },
      ],
    },
  ],
  JETBLUE: [
    {
      Title: "JETBLUE",
      content: [
        {
          type: "text",
          text:
            "<b>MORE LEGROOM STILTWALKERS</b><br>Dressed as regular travelers and branded only with a luggage tag, teams of stilt walkers were sent out<br>to walk the streets of five major destination cities. They interacted with locals, told them about the<br>new legroom, and did other normal things that any 10 foot tall man or woman would do.",
        },
        {
          type: "imagesCols",
          cols: 4,
          pictures: [
            "/static/works/content/JETBLUE_2.png",
            "/static/works/content/JETBLUE_3.png",
            "/static/works/content/JETBLUE_1.png",
            "/static/works/content/JETBLUE_4.png",
          ],
        },
        {
          type: "text",
          text:
            "<b>LEGROOM SUBWAY TAKEOVER</b><br>To celebrate its 7th anniversary, JetBlue Airways removed a row of seats. Becoming the airline<br>with the most legroom in Coach. These Subway pannels with suggestions on what to do with<br>the extra legroom were placed inside subway cars in main destination cities across the U.S.",
        },
        {
          type: "slides",
          pictures: [
            "/static/works/content/JB_Subway_1.png",
            "/static/works/content/JB_Subway_2.png",
            "/static/works/content/JB_Subway_3.png",
          ],
        },
        {
          type: "slides",
          pictures: [
            "/static/works/content/Subway_Photo1.png",
            "/static/works/content/Subway_Photo2.png",
          ],
        },
        {
          type: "text",
          text:
            "<b>MORE LEGROOM PARTY BLOWER</b><br>To celebrate its 7th anniversary, JetBlue removed a row of seats. Becoming the airline with the most<br>legroom in coach. This party blower was distributed in the streets of major destination cities across<br>the U.S. to passengers before flights, events and press conferences. We even found a couple being sold on eBay.",
        },
        { type: "image", src: "/static/works/content/JB_Blower.png" },
      ],
    },
  ],
  "BURGER KING": [
    {
      Title: "BURGER KING",
      content: [
        {
          type: "text",
          text:
            "<b>THE KING AT THE PRESIDENT’S BOX</b><br>BK sponsors Spanish League's underdog, Getafe F.C. During a 2010 home game versus Real Madrid,<br>we surprised the Futbol world by breaking tradition. Instead of having both teams Presidents sitting<br>next to each other in the Box, we convinced Getafe's President to give up his seat for the King. <br>Real Madrid's President, Florentino Perez, wasn't too happy about it. Spanish fans, on the contrary,<br>enjoyed 90+ minutes of non-stop laughter. The next day, it was on every newspaper and TV<br>station in the country. Some even say it was the best part of the game.",
        },
        { type: "video", url: "https://www.youtube.com/embed/fZ05oTaKJeI" },
        { type: "text", text: "<b>TV - GRILLED CHEESE</b>" },
        { type: "video", url: "https://www.youtube.com/embed/wtIk6NuBob8" },
        {
          type: "text",
          text:
            '<b>ELGETASOMOSTODOS.COM</b><br>For the 2010 season, BK became Getafe\'s official sponsor. To announce this partnership,<br>we created a site where team fans, "The Azulones" or "The Blues" could add themselves<br>to the team\'s official picture. The message: Getafe is all of us.',
        },
        {
          type: "text",
          text:
            "<b>Homepage copy reads:</b> Some of us jump onto the field. Some of us cheer from the stands.<br>But wherever we are, through good and bad, we're all one. The King has blue blood and<br>invites you to join the team.",
        },
        { type: "image", src: "/static/works/content/BK_site_lrg_2_4.gif" },
        { type: "text", text: "<b>BURGER KING - PRINT AD</b>" },
        { type: "image", src: "/static/works/content/BK-Poster.png" },
      ],
    },
  ],
  "CUERVO GAMES": [
    {
      Title: "CUERVO GAMES",
      content: [
        {
          type: "text",
          text:
            "<b>JOSE CUERVO BETS ON ‘CUERVO GAMES ELEMENTS’ FOR SALES BOOST.</b><br><br>The Cuervo Games are best described as a mix between “American Ninja Warrior” and “Wipeout,” staged to illustrate the Cuervo family's process of making tequila. The Games brought live competition and concerts to consumers across the country and around the world.<br><br>The competition visited over 20 cities and was live streamed online. Over 85,000 people attended events in person, and over 400,000 viewers tuned in online to create a total of over 200 million media impressions.",
        },
        {
          type: "press",
          title: "PRESS",
          links: [
            {
              name: "ADAGE",
              href:
                "http://adage.com/article/news/jose-cuervo-bets-cuervo-games-sales-boost/143027/",
            },
          ],
        },
        { type: "video", url: "https://player.vimeo.com/video/17520342" },
        {
          type: "text",
          text:
            "<b>2010 NATIONAL TOUR</b><br>5 events inspired by the tequila making<br>traditions of the Cuervo family",
        },
        { type: "image", src: "/static/works/content/JoseCuervo_1.jpg" },
        { type: "text", text: "Walk-Ons T-Shirts for competition" },
        { type: "image", src: "/static/works/content/JoseCuervo_2.jpg" },
        { type: "text", text: "The Mayan Mist" },
        { type: "image", src: "/static/works/content/JoseCuervo_3.jpg" },
        { type: "text", text: "The Barrel Roll" },
        { type: "image", src: "/static/works/content/JoseCuervo_4.jpg" },
        { type: "image", src: "/static/works/content/JoseCuervo_5.jpg" },
        { type: "text", text: "The Tahona Tumber" },
        { type: "image", src: "/static/works/content/JoseCuervo_6.jpg" },
        { type: "image", src: "/static/works/content/JoseCuervo_7.jpg" },
      ],
    },
  ],
  "HOLIDAY INN EXPRESS": [
    {
      Title: "HOLIDAY INN EXPRESS",
      content: [
        { type: "text", text: "<b>TV - BABY</b>" },
        { type: "video", url: "https://www.youtube.com/embed/Bn123bqsfok" },
        { type: "text", text: "<b>TV - RAPPER</b>" },
        { type: "video", url: "https://www.youtube.com/embed/WelUehmS0nw" },
        { type: "text", text: "<b>TV - FAINTER</b>" },
        { type: "video", url: "https://www.youtube.com/embed/bK--Ic-azZk" },
        { type: "text", text: "<b>TV - SECOND PLACE</b>" },
        { type: "video", url: "https://www.youtube.com/embed/n0cfidFddb8" },
        { type: "text", text: "<b>TV - FUGITIVE</b>" },
        { type: "video", url: "https://www.youtube.com/embed/jwP6T6MX77U" },
        { type: "text", text: "<b>TV - ANTHEM SINGER</b>" },
        { type: "video", url: "https://www.youtube.com/embed/VR2LQpWxMzY" },
      ],
    },
  ],
  "ELF YOURSELF": [
    {
      Title: "ELF YOURSELF",
      content: [
        {
          type: "text",
          text:
            "How in the world do you get people to think about shopping for holiday gifts at an office supply store?<br>Well, using the office cubicle as our medium, we created twenty holiday-themed websites. Elf Yourself<br>alone became a record-breaking phenomenon. Garnering 193 million visits in five weeks.<br>Making it one of the most viral efforts of all time.",
        },
        { type: "video", url: "https://www.youtube.com/embed/smWooaiB7cg" },
      ],
    },
  ],
  EQUINOX: [
    {
      Title: "EQUINOX - Happily Ever - Print",
      content: [
        { type: "image", src: "/static/works/content/Eq1_o_1051.jpg" },
        { type: "image", src: "/static/works/content/Eq2_o_1050.jpg" },
        { type: "image", src: "/static/works/content/Eq3_o_1050.jpg" },
        { type: "image", src: "/static/works/content/Eq4_o_1051.jpg" },
      ],
    },
  ],
  NASCAR: [
    {
      Title: "NASCAR",
      content: [
        {"type":"video", "url":"https://www.youtube.com/embed/QItY9ZK26Y8"},
        {"type":"video", "url":"https://www.youtube.com/embed/kxBdef388ro"},
        {"type":"video", "url":"https://www.youtube.com/embed/kYDlqW17Z3k"},      ],
    },
  ],
  "HEWLETT PACKARD": [
    {
      Title: "HEWLETT PACKARD",
      content: [
        {
          type: "text",
          text:
            "<b>INSTANT GRATIFICATION - PRINT CAMPAIGN</b><br>Printer is shown actual size in the magazine and photo insert is printed on HP paper to show its quality.",
        },
        { type: "image", src: "/static/works/content/HP_2.jpg" },
        { type: "image", src: "/static/works/content/HP_3.jpg" },
        { type: "image", src: "/static/works/content/HP_1.jpg" },
        {
          type: "imagesCols",
          cols: 3,
          pictures: [
            "/static/works/content/HP_4.jpeg",
            "/static/works/content/HP_5.jpeg",
            "/static/works/content/HP_6.jpeg",
          ],
        },
      ],
    },
  ],
  SATURN: [
    {
      Title: "SATURN",
      content: [
        {
          type: "text",
          text:
            "<b>SATURN ENGINEERING PAMPHLETS</b><br>The pamphlets were handed out at Saturn dealerships and sent to the press to announce<br>the launch of two new models. The Saturn AURA and the Saturn SKY.",
        },
        { type: "image", src: "/static/works/content/Saturn_1.jpg" },
        { type: "image", src: "/static/works/content/Saturn_2.jpg" },
        {
          type: "text",
          text:
            "<b>ORGAN DONOR</b><br>USA Today full-page newspaper ad.<br>Reader turns ad upside down to get the message: You can turn things around.",
        },
        { type: "image", src: "/static/works/content/Saturn_SideToSide.png" },
        { type: "image", src: "/static/works/content/Saturn_Zoom_1.jpg" },
        { type: "image", src: "/static/works/content/Saturn_Zoom2.jpg" },
      ],
    },
  ],
  CUENTAS: [
    {
      Title: "CUENTAS - UN BANCO DE GENTE",
      content: [
        { type: "image", src: "/static/works/content/Cuentas_1.png" },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-2.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-3.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-4.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-5.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-6.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-7.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-8.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-9.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-10.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-11.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-12.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-13.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-14.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-15.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-16.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-17.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-18.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-19.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-20.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-21.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-22.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-23.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-24.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-25.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-26.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-27.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-28.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-29.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-30.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-31.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-32.png",
        },
        {
          type: "image",
          src: "/static/works/content/Cuentas_Brand-Book_FinalEspanol-33.png",
        },
      ],
    },
  ],
  "WÜSTHOFF KNIVES": [
    {
      Title: "WÜSTHOFF KNIVES",
      content: [
        { type: "image", src: "/static/works/content/Wustoff_Prin1.png" },
        { type: "image", src: "/static/works/content/Wustoff_Print2.png" },
        { type: "image", src: "/static/works/content/Wustoff_Print3.png" },
      ],
    },
  ],
  CARHARTT: [
    {
      Title: "CARHARTT",
      content: [
        { type: "image", src: "/static/works/content/Carhart_1.png" },
        { type: "image", src: "/static/works/content/Carhart_2.png" },
        { type: "image", src: "/static/works/content/Carhart_3.png" },
      ],
    },
  ],
  NIKE: [
    {
      Title: "NIKE PRINT",
      content: [
        {
          type: "imagesCols",
          cols: 3,
          pictures: [
            "/static/works/content/nikeBobsled_1_352.jpg",
            "/static/works/content/nikeDive_2_352.jpg",
            "/static/works/content/nikeRow_3_352.jpg",
          ],
        },
      ],
    },
  ],
  "GREEN GARAGE": [
    {
      Title: "GREEN GARAGE",
      content: [
        { type: "text", text: "<b>BUSINESS CARD</b>" },
        {
          type: "image",
          src: "/static/works/content/gg_business_card_o_907.jpg",
        },
        { type: "text", text: "<b>LETTER TO OBAMA - PRINT</b>" },
        { type: "image", src: "/static/works/content/gg_obama_670.jpg" },
      ],
    },
  ],
  SMIRNOFF: [
    {
      Title: "SMIRNOFF",
      content: [
        { type: "video", url: "https://www.youtube.com/embed/g1NYMI4MEvs" },
      ],
    },
  ],
  "CONSUMER REPORTS": [
    {
      Title: "CONSUMER REPORTS",
      content: [
        {
          type: "imagesCols",
          cols: 3,
          pictures: [
            "/static/works/content/Screen-shot-2011-04-06-at-7.57.49-PM_409.png",
            "/static/works/content/Screen-shot-2011-04-06-at-7.58.01-PM_411.png",
            "/static/works/content/Screen-shot-2011-04-06-at-7.58.14-PM_407.png",
          ],
        },
      ],
    },
  ],
};



//////////////////
// WEBPACK FOOTER
// ./static/works.js
// module id = VCOz
// module chunks = 1